module.exports = __webpack_public_path__ + "static/img/logo.909954e8.png";